module.exports = __webpack_public_path__ + "images/store_case_study/bersurga-pic2_374b28d7cf21dbd71d748f6f8b56738d.jpg";